










































































import { Component, Vue, Prop } from 'vue-property-decorator';
import user from '@/store/modules/user';
import { colors } from '../config';

@Component
export default class CompassItemRatio extends Vue {
  @Prop() readonly overviews: any | undefined;
  @Prop() readonly rankings: any | undefined;
  @Prop() readonly years: number | undefined;
  @Prop() readonly industry: boolean | undefined;
  @Prop() readonly keyValue: string | undefined;

  get isSie() {
    return user.activeSie !== null;
  }

  // För Bolagskompass och Flerårskompass
  getStyle(index: number) {
    switch (index) {
      case 0:
        return `border-color: ${colors.Primary};`;
      case 1:
        return `border-color: ${colors.Secondary};`;
      default:
        return `border-color: ${colors.Tertiary};`;
    }
  }

}
